import { isEqual, uniqBy } from 'lodash/fp';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import useTranslatedString from '../../../../../utilities/useTranslatedString';
import FilterGroup from '../../../StandardApplicationEntrypoint/CarListingPage/CarFilter/FilterGroup';
import { useCarListingState } from '../CarListingStateProvider';

const CarSubmodelFilter = () => {
    const { t } = useTranslation(['carList']);
    const translateString = useTranslatedString();
    const {
        state: { filters, modelFilter, submodelFilter },
        actions,
    } = useCarListingState();

    const onChange = useCallback(
        (value: string[]) => {
            actions.setSubmodelFilter(value.length > 0 ? value : null);
            actions.setScroll(false);
            actions.setPage(1);
        },
        [actions]
    );

    const options = useMemo(
        () =>
            uniqBy(
                'value',
                filters.submodels
                    .filter(submodel =>
                        modelFilter?.length > 0
                            ? modelFilter.some(model => model === submodel.parentModel.name.defaultValue)
                            : true
                    )
                    .filter(Boolean)
                    .map(submodel => ({
                        label: translateString(submodel.name),
                        value: translateString(submodel.name),
                    }))
            ),
        [filters.submodels, modelFilter, translateString]
    );

    const previousOptionsRef = useRef(options);

    useEffect(() => {
        if (!isEqual(previousOptionsRef.current, options)) {
            // reset selected models because option changed
            actions.setSubmodelFilter([]);
            previousOptionsRef.current = options;
        }
    }, [options, actions, previousOptionsRef]);

    if (!options?.length || options.length === 1) {
        return null;
    }

    return (
        <FilterGroup
            onChange={onChange}
            options={options}
            title={t('carList:filter.carSubmodelTitle')}
            value={submodelFilter || []}
        />
    );
};

export default CarSubmodelFilter;
